import React from 'react'
import { Link } from 'react-router-dom'
import KarteraAdminTemplate from '../../../template/KarteraAdminTemplate'
import KarteraPageHeader from '../../../template/kartera/KarteraPageHeader'
import { ChevronRightIcon } from '../../../template/kartera/icons'
import { STATUS_LABELS, useIntegrationListModel } from './integration-list-model'
import type { IntegrationStatus } from './integration-list-model'

const statusClass = (status: IntegrationStatus) => {
    if (status === 'connected') return 'bg-k-ok-soft text-k-ok'
    if (status === 'loading') return 'bg-k-line-soft text-k-muted'
    return 'bg-k-line-soft text-k-ink-2'
}

const IntegrationList = () => {
    const model = useIntegrationListModel()

    return (
        <KarteraAdminTemplate title="Integraciones">
            <div className="mx-auto flex w-full max-w-[880px] flex-col gap-[18px]">
                <KarteraPageHeader
                    title="Integraciones"
                    description="Conecta Kartera 365 con las herramientas que ya usas."
                    backTo={model.backTo}
                    backLabel="Configuración"
                />

                <section className="k-card">
                    <h2 className="k-card-title">Disponibles</h2>
                    <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
                        {model.integrations.map((integration) => (
                            <Link
                                key={integration.id}
                                to={integration.to}
                                state={model.linkState}
                                className="group flex min-h-[88px] items-center gap-3.5 rounded-[14px] border border-k-line bg-k-surface px-4 py-3 hover:border-k-line-strong hover:bg-k-hover"
                            >
                                <span className="flex h-12 w-12 shrink-0 items-center justify-center overflow-hidden rounded-xl border border-k-line-soft bg-white p-1.5">
                                    <img src={integration.icon} alt="" className="max-h-full max-w-full object-contain" />
                                </span>
                                <span className="flex min-w-0 flex-1 flex-col gap-0.5">
                                    <span className="flex flex-wrap items-center gap-2">
                                        <span className="text-sm font-bold text-k-ink">{integration.name}</span>
                                        <span className={`rounded-full px-2 py-0.5 text-[11px] font-bold ${statusClass(integration.status)}`}>
                                            {STATUS_LABELS[integration.status]}
                                        </span>
                                    </span>
                                    <span className="text-[13px] text-k-muted">{integration.description}</span>
                                </span>
                                <ChevronRightIcon className="shrink-0 text-k-muted-2 group-hover:text-brand-indigo" />
                            </Link>
                        ))}
                    </div>
                </section>
            </div>
        </KarteraAdminTemplate>
    )
}

export default IntegrationList
